import { render, staticRenderFns } from "./approvedDialog.pug?vue&type=template&id=b732c14e&scoped=true&lang=pug&"
import script from "./approvedDialog.ts?vue&type=script&lang=ts&"
export * from "./approvedDialog.ts?vue&type=script&lang=ts&"
import style0 from "./approvedDialog.styl?vue&type=style&index=0&id=b732c14e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b732c14e",
  null
  
)

export default component.exports